import React, { useState } from 'react';
import './TimezoneConverter.css';
import moment from 'moment-timezone';
import Select from 'react-select';

const TimezoneConverter = () => {
  const [selectedTimezone, setSelectedTimezone] = useState('');
  const [convertedTime, setConvertedTime] = useState('');

  const timezones = moment.tz.names().map((tz) => ({ value: tz, label: tz }));

  const handleTimezoneChange = (selectedOption) => {
    setSelectedTimezone(selectedOption.value);
    updateConvertedTime(selectedOption.value);
  };

  const updateConvertedTime = (timezone) => {
    const currentTime = moment();
    const convertedTime = currentTime.tz(timezone).format('YYYY-MM-DD HH:mm:ss');
    setConvertedTime(convertedTime);
  };

  return (
    <div className="tool-page-container">
      <div className="tool-page-content">
        <h1>Timezone Converter</h1>
        <p className="tool-description">
          Convert current time to different timezones around the world.
        </p>

        <div className="tool-section">
          <label className="tool-label">Select Timezone:</label>
          <Select
            options={timezones}
            value={timezones.find((tz) => tz.value === selectedTimezone)}
            onChange={handleTimezoneChange}
            placeholder="Select a timezone"
            className="timezone-select"
          />
        </div>

        {selectedTimezone && (
          <div className="result-section">
            <h2>Result</h2>
            <div className="result-item">
              <span className="result-label">Selected Timezone:</span>
              <span className="result-value">{selectedTimezone}</span>
            </div>
            <div className="result-item">
              <span className="result-label">Converted Time:</span>
              <span className="result-value">{convertedTime}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimezoneConverter;
